<template>
  <router-view/>
  <FloatingChatWidget v-if="show_floating_chat" />
</template>

<script>
import FloatingChatWidget from '@/components/FloatingChatWidget/FloatingChatWidget.vue';

const FLOATING_CHAT_HIDDEN_ROUTE_NAMES = new Set([
  'Login',
  'Register',
  'Reset',
  'ResetPasswordSent',
  'ResetLinkSent',
  'MicrosoftSSOSuccess',
  'MicrosoftMarketplaceActivate',
  'MicrosoftMarketplaceSuccess',
  'MicrosoftMarketplaceError',
  'Chat',
  'Create',
  'Profile',
  'IndividualDashboard',
  'Settings',
  'Permission',
  'Ziva',
  'PlatformManagement',
  'Playground',
  'Role',
  'RolePermissions',
  'SupersetManager',
  'SystemConfigure',
  'UserPermissions',
  'Drive',
  'AuditTrail',
  'MainSettings',
]);

export default {
  name: 'App',
  components: { FloatingChatWidget },
  computed: {
    show_floating_chat() {
      return Boolean(localStorage.getItem('token'))
        && !FLOATING_CHAT_HIDDEN_ROUTE_NAMES.has(this.$route.name)
        && this.$route.meta?.public !== true
        && this.$route.meta?.requires_auth !== false;
    },
  },
};
</script>

<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden !important;
  text-align: center;

}
</style>